import { Skeleton } from "@mui/material";
import PropTypes from "prop-types";
import { Fragment } from "react";

const LoadingComponent = ({
  count = 1,
  WrapperComponent = Fragment,
  wrapperComponentProps = {},
  ...skeletonProps
}) =>
  Array(count)
    .fill(null)
    .map((_, index) => (
      <WrapperComponent key={index + Math.random()} {...wrapperComponentProps}>
        <Skeleton {...skeletonProps} />
      </WrapperComponent>
    ));

LoadingComponent.propTypes = {
  count: PropTypes.number,
  WrapperComponent: PropTypes.element,
  wrapperComponentProps: PropTypes.object,
};

export default LoadingComponent;
